module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABTElEQVRIS7XUvytHURzG8RerlNEkFhYT/gBK+ZksSjIZyCwZGQ0yKkrCIAaSQbFIWLCYJGW2W2w6urfE/brHvV+37nLvOc/7c87zeT41/vmp+Wd9sYBuXBQpJgawgjn0FIHkATYxlQBWq3mCBmxhFOPYLyIe9mSdoAXbaMcIroqKZwE6sINaDOGljPh3QC928Yh+vJcV/woYwDGuC4qGFn7A0ff9qQdlAc0I733SFM8p6KvJZa8oeLaGJtTjLcvkVhyWNDlUf47ZSm0avl+WaNNhnKANT78lORhWJGjBi9DeE9jLGxXLWPjjqKhL7n8eK3mAcF2TST5ih10XbtGHsxhAgHQmLRgTk0UsoRGvsYAY4bBmDAeYwcZvXRQrmK4LQQ1XGYw9xWBW0LJEp7EeSbtJpvBn5bGAdATkMe7S5FaaRXkChf9X2+QfhXwA8H87GVxgsfcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/返回.png
// module id = +SZE
// module chunks = 1